import { AuthorizedBaseAxios } from 'core/axios/axios';
import { NewPasswordFormModel } from 'pages/NewPassword/NewPasswordForm';
import { ForgetPasswordFormModel } from 'pages/ForgetPassword';
import { environment } from 'config/environment';

export const setNewPassword = (dto: NewPasswordFormModel) => {
  return AuthorizedBaseAxios.post<void>(`api/users/password`, dto);
};

export const forgetPassword = (dto: ForgetPasswordFormModel) => {
  return AuthorizedBaseAxios.post<void>(`api/users/password/remind`, dto, {
    headers: {
      Authorization: `Basic ${environment.baseAuth}`,
    },
  });
};
